import React from "react";
import ReactDOM from "react-dom";
import loadingSpinner from "../../assets/images/loading-spinner.gif";
import successIcon from "../../assets/images/congrats.png";
import errorIcon from "../../assets/images/error.png";
import Button from "../ui/Button";
import { useTranslation } from "react-i18next";
import studio from "../../components/modals/StudioModal.module.css";

interface CloneVoiceStatusModalProps {
    isOpen: boolean;
    status: "waiting" | "success" | "error";
    title: string;
    subtitle?: string;
    onClose: () => void;
}

const CloneVoiceStatusModal: React.FC<CloneVoiceStatusModalProps> = ({ isOpen, status, title, subtitle, onClose }) => {
    const { t } = useTranslation();

    if (!isOpen) {
        return null;
    }

    const getImage = () => {
        switch (status) {
            case "success":
                return successIcon;
            case "error":
                return errorIcon;
            case "waiting":
            default:
                return loadingSpinner;
        }
    };

    const modal = (
        <div className={studio.overlayTop}>
            <div className={studio.contentAnimated}>
                <div className={studio.logoWrap}>
                    <img
                        src={getImage()}
                        className={status === "waiting" ? "spinner" : ""}
                        alt="Status"
                        style={{ width: "100px", height: "100px" }}
                    />
                </div>
                <h1 className={studio.title}>{title}</h1>
                {subtitle && (
                    <p
                        className={studio.subtitle}
                        style={{
                            marginTop: "16px",
                            marginBottom: "24px",
                            color: "#666",
                            fontSize: "14px",
                            lineHeight: "1.5",
                            whiteSpace: "pre-line",
                            textAlign: "center",
                        }}
                    >
                        {subtitle}
                    </p>
                )}
                {(status === "success" || status === "error") && (
                    <div className={studio.buttonsCentered}>
                        <Button variant="outline" shape="pill" label={t("close")} onClick={onClose} />
                    </div>
                )}
            </div>
        </div>
    );

    return ReactDOM.createPortal(modal, document.body);
};

export default CloneVoiceStatusModal;
